module.exports = __webpack_public_path__ + "img/3.956130dc.png";